<template>
    <li ref="monitorIfScrolledImage" data-animation="offset" :class="inView ? 'in-view' : ''">
        <slot></slot>
    </li>
</template>

<script>
import InViewportAnimationMixin from '~/mixins/InViewportAnimationMixin';
export default {
    mixins: [InViewportAnimationMixin],
    data() {
        return {
            inView: false,
        };
    },
    methods: {
        onEnter() {
            this.inView = true;
        },
        onExit() {},
    },
};
</script>

<style lang="scss" scoped>
li {
    list-style-type: none;
    position: relative;
    width: 2px;
    margin: 0 auto;
    background: $color-bg;

    &:last-of-type {
        background: linear-gradient($color-bg 70%, $color-primary-dark 98%);
    }

    div {
        position: relative;
        width: 20rem;
        padding-bottom: 3rem;
        padding-left: 25px;

        visibility: hidden;
        opacity: 0;
        transition: all 0.5s ease-in-out;

        &::before {
            content: '';
            position: absolute;
            border-style: solid;
            width: 25px;
            height: 25px;
            border-color: $color-bg;
            border-radius: 50%;
            background-color: $color-primary-dark;
        }

        &::after {
            content: '';
            position: absolute;
            display: inline-block;
            height: 0.5em;
            width: 67.5px;
            top: 12.5px;
            right: -80px;
            border-top: 1px solid white;
        }

        p:last-of-type {
            margin-bottom: 0;
        }

        @media screen and (min-width: 768px) {
            padding-bottom: 1px;
        }
    }

    &::after {
        transition: background 0.5s ease-in-out;
    }
}

li:nth-child(odd) div {
    left: 80px;
    &::before {
        left: -15px;
    }

    &::after {
        left: -80px;
    }

    transform: translate3d(200px, 0, 0);
}

li:nth-child(even) div {
    left: -380px;
    padding-right: 25px;
    p {
        text-align: right;
    }

    &::before {
        right: -15px;
        top: 1px;
    }

    &::after {
        right: -80px;
    }

    transform: translate3d(-200px, 0, 0);
}

::v-deep a {
    text-decoration: underline;
    color: $color-text-inverted;
    &:hover {
        color: $color-secondary;
    }
}

::v-deep b {
    color: $color-text-inverted;
}

@media screen and (max-width: 576px) {
    li:nth-child(even) div {
        transform: translate3d(200px, 0, 0);
    }
}

li.in-view div {
    transform: none;
    visibility: visible;
    opacity: 1;
}

// MEDIA QUERIES
@media screen and (max-width: 576px) {
    li div {
        width: 250px;
    }
    li:nth-child(even) div {
        left: -289px;
    }
}

@media screen and (max-width: 576px) {
    li {
        margin-left: 20px;
        width: 1px;

        &::before {
            content: '';
            position: absolute;
            border-style: solid;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            top: -2px;
            left: -12px;
            background-color: $color-primary-dark;
            border: 1px solid $color-bg;
        }
    }
    li div {
        width: calc(100vw - 91px);
        left: 15px !important;

        &::after {
            display: none;
        }

        &::before {
            display: none;
        }
    }

    li:nth-child(even) div {
        left: 80px;
        p {
            text-align: left;
        }

        &::before {
            left: -15px;
            width: 25px;
            height: 25px;
            border-color: $color-bg;
            border-radius: 50%;
            top: -2px;
        }
    }
}

@media screen and (min-width: 576px) {
    li:first-of-type {
        &::before {
            content: '';
            position: absolute;
            border-style: solid;
            width: 2px;
            height: 15px;
            border-color: $color-primary-dark;
            top: -2px;
            right: -1px;
        }
    }
}
</style>
